import _ from 'lodash';

import { SKIP_FORBIDDEN_RESPONSE_CONFIG } from 'constants/http';
import { getConditionalObject } from 'utils/data';

/**
 * Read-path client for the shared Audit.Read endpoints. The host that maps them is configurable
 * (`basePath`) because each adopting service exposes them under its own route — the first host is
 * the Skynet.Loans `AuditController` at `api/audit` (via `httpLoansApi`).
 */
export class AuditApi {
  #http;
  #basePath;

  constructor(http, basePath = 'api/audit') {
    this.#http = http;
    this.#basePath = basePath;
  }

  /** `params` carries optional read flags (e.g. `includeShadowed`) merged into the query. */
  getEntityAuditHistory({ entityType, entityId, page = 1, pageSize, basePath, params = null }) {
    return this.#http.get(`/${basePath ?? this.#basePath}/history`, {
      ...SKIP_FORBIDDEN_RESPONSE_CONFIG,
      params: { entityType, entityId, page, pageSize, ...params },
    });
  }

  getEntityAuditRecordDetail({ auditId, basePath, params = null }) {
    return this.#http.get(`/${basePath ?? this.#basePath}/${auditId}`, {
      ...SKIP_FORBIDDEN_RESPONSE_CONFIG,
      ...getConditionalObject(!_.isEmpty(params), { params }),
    });
  }
}
